import { useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';

import AddWrestlerSteps from './AddWrestlerSteps';
import { AddAthleteFormValues, getInitialValues, newWrestlerSchema } from './AddWrestlerUtils';
import { Dialog } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import NextBackButtonGroup from './NextBackButtonGroup';
import useModalControl from '@hooks/useModalControl';

export const TEAM_MEMBER_MODAL = 'team-member';
export type AthleteType = typeof TEAM_MEMBER_MODAL | 'child';
export default function AddWrestlerModal({ type }: { type: AthleteType }) {
    const { setShowAddTeamMember, setShowAddChildModal } = useModalControl();
    const [currentAddWrestlerStep, setCurrentAddWrestlerStep] = useState(0);
    const onNextClick = () => setCurrentAddWrestlerStep(currentAddWrestlerStep + 1);

    const formMethods = useForm<AddAthleteFormValues>({
        defaultValues: getInitialValues(),
        resolver: yupResolver(newWrestlerSchema),
    });

    // onPrevClick decrements the page by 1 unless we are already at page 0
    const onPrevClick = () => {
        const prevPage = Math.max(0, currentAddWrestlerStep - 1);
        setCurrentAddWrestlerStep(prevPage);
    };

    return (
        <FormProvider {...formMethods}>
            <form>
                <Dialog
                    open={true}
                    onClose={() => {
                        setShowAddTeamMember(false);
                        setShowAddChildModal(false);
                    }}
                    sx={{ '& .MuiDialog-paper': { padding: 4, minWidth: 'min(50vw, 650px)' } }}
                >
                    <AddWrestlerSteps
                        step={currentAddWrestlerStep}
                        // goToNextStep={onNextClick}
                        // goToPrevStep={onPrevClick}
                    />
                    <NextBackButtonGroup
                        step={currentAddWrestlerStep}
                        // Go back one page
                        onClose={() => {
                            setShowAddTeamMember(false);
                            setShowAddChildModal(false);
                        }}
                        onPrevClick={onPrevClick}
                        onNextClick={onNextClick}
                        addingToTeam={type === TEAM_MEMBER_MODAL}
                    />
                </Dialog>
            </form>
        </FormProvider>
    );
}
